module.exports = __webpack_public_path__ + "img/cash-success.ab507b22.png";